import React from "react";
import {useSelector} from "react-redux";
import {uploadCodReceipt, submitCodReceipts, uploadCodClick, deletePrevUploadedCodReceipt} from "./redux/stdCodPortalSlice";
import {AppState} from "../../config/redux/reducers";
import BaseUploadReceipt from "../shared/codUploadReceiptBase";
import {createPayloadToDeleteUploadedFile} from "../../mocks/codPortal/response.transforms";

interface StdCODUploadReceiptProps {
  open: boolean;
  hub: any;
  date: any;
  closePopup: () => void;
}

const StdCODUploadReceipt = (props: StdCODUploadReceiptProps) => {
  const {
    stdDraftReceiptData,
    isStdFileUploaded,
    stdReceiptDataAfterUpload,
    stdUploadError,
    stdUploadErrorCode,
    stdReceiptsSubmittedFlag,
    stdReceiptDataAfterSubmit,
    isErrorOnStdUpload
  } = useSelector((state: AppState) => state.stdCodPortal);

  return (
    <BaseUploadReceipt
      {...props}
       reduxStates={{
              draftReceiptData: stdDraftReceiptData,
              isFileUploaded: isStdFileUploaded,
              receiptDataAfterUpload: stdReceiptDataAfterUpload,
              uploadError: stdUploadError,
              uploadErrorCode: stdUploadErrorCode,
              receiptsSubmittedFlag: stdReceiptsSubmittedFlag,
              receiptDataAfterSubmit: stdReceiptDataAfterSubmit,
              isErrorOnUpload: isErrorOnStdUpload
            }}
            actions={{
              uploadReceipt: uploadCodReceipt,
              submitReceipts: submitCodReceipts,
              uploadClick: uploadCodClick,
              deletePrevUploadedReceipt: deletePrevUploadedCodReceipt
            }}
            transforms={{
              createPayloadToDeleteUploadedFile
            }}
    />
  );
};

export default StdCODUploadReceipt;